module.exports = __webpack_public_path__ + "img/2d28b54cadf765d0c22ea2143359713b.png";